// Wave V.5 — Shared helpers for rail items. Extracted from StageRailItem
// so the per-level components in separate files can share logic without
// triggering Babel AST self-recursion detection.
import { CheckCircle2, Circle, CircleDot, Lock, AlertTriangle, CircleDashed } from "lucide-react";

export const RAIL_STATUS_META = {
  not_started:       { Icon: Circle,        color: "var(--pf-text-dim)", label: "Not started" },
  ready:             { Icon: CircleDashed,  color: "#3B82F6",            label: "Ready to start (deps met)" },
  in_progress:       { Icon: CircleDot,     color: "var(--pf-spark)",    label: "In progress" },
  complete:          { Icon: CheckCircle2,  color: "#10B981",            label: "Complete" },
  approved:          { Icon: CheckCircle2,  color: "var(--pf-accent)",   label: "Approved" },
  blocked:           { Icon: Lock,          color: "#EF4444",            label: "Blocked" },
  revision_required: { Icon: AlertTriangle, color: "#F59E0B",            label: "Revision required (upstream changed)" },
};

export function effectiveStatus(stageSpec, state, flatByCode) {
  const raw = (state && state.status) || "not_started";
  if (raw !== "not_started") return raw;
  const hardDeps = stageSpec.hard_deps || [];
  if (!hardDeps.length) return "ready";
  const unmet = hardDeps.filter((d) => {
    const ds = flatByCode[d];
    return !ds || !["complete", "approved"].includes(ds.status);
  });
  return unmet.length ? "locked" : "ready";
}

export function findInCatalogue(catalogue, code) {
  for (const s of (catalogue || [])) {
    if (s.code === code) return s;
    const hit = findInCatalogue(s.sub_stages || [], code);
    if (hit) return hit;
  }
  return null;
}
